import React from 'react';
import { BuildingIcon, SearchIcon, UsersIcon, CpuIcon, CheckCircleIcon } from 'lucide-react';
export function MarketingPricing() {
  return <section className="py-24 bg-slate-50" data-id="element-4983">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4984">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-4985">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-4986">
            Pricing for every{' '}
            <span className="text-blue-600" data-id="element-4987">local business data</span> workflow
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-4988">
            Pay only for the local business contacts you use. Every account
            starts with free credits to build your first audience.
          </p>
        </div>

        {/* Pricing Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-4989">
          {/* Search Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-4990">
            <div className="flex items-center gap-3 mb-4" data-id="element-4991">
              <SearchIcon className="w-5 h-5 text-slate-400" data-id="element-4992" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-4993">
                Search audiences
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-4994">
              Find local businesses by location, category, and revenue for
              campaign targeting
            </p>
            <div data-id="element-4995">
              <div className="flex items-baseline gap-2" data-id="element-4996">
                <span className="text-4xl font-bold text-slate-900" data-id="element-4997">Free</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-4998">unlimited searches</p>
            </div>
          </div>

          {/* Find People Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-4999">
            <div className="flex items-center gap-3 mb-4" data-id="element-5000">
              <UsersIcon className="w-5 h-5 text-slate-400" data-id="element-5001" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-5002">
                Find decision makers
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-5003">
              Get verified owner contacts for direct outreach and ad targeting
            </p>
            <div className="space-y-4" data-id="element-5004">
              <div data-id="element-5005">
                <div className="flex items-baseline gap-2" data-id="element-5006">
                  <span className="text-4xl font-bold text-slate-900" data-id="element-5007">
                    from $3
                  </span>
                </div>
                <p className="text-sm text-slate-500 mt-1" data-id="element-5008">
                  per 100 contacts found
                </p>
              </div>
              <div className="grid grid-cols-3 gap-3 pt-4 border-t border-slate-100" data-id="element-5009">
                <div data-id="element-5010">
                  <div className="text-lg font-bold text-slate-900" data-id="element-5011">$3</div>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-5012">per 100 names</p>
                </div>
                <div data-id="element-5013">
                  <div className="text-lg font-bold text-slate-900" data-id="element-5014">$6</div>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-5015">per 100 emails</p>
                </div>
                <div data-id="element-5016">
                  <div className="text-lg font-bold text-slate-900" data-id="element-5017">$24</div>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-5018">per 100 phones</p>
                </div>
              </div>
            </div>
          </div>

          {/* Detect Tech Stack Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-5019">
            <div className="flex items-center gap-3 mb-4" data-id="element-5020">
              <CpuIcon className="w-5 h-5 text-slate-400" data-id="element-5021" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-5022">
                Detect tech stack
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-5023">
              Identify what tools local businesses use to personalize your
              campaigns
            </p>
            <div data-id="element-5024">
              <div className="flex items-baseline gap-2" data-id="element-5025">
                <span className="text-4xl font-bold text-slate-900" data-id="element-5026">$6</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-5027">
                per 100 records enriched
              </p>
            </div>
          </div>

          {/* Export Leads Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-5028">
            <div className="flex items-center gap-3 mb-4" data-id="element-5029">
              <BuildingIcon className="w-5 h-5 text-slate-400" data-id="element-5030" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-5031">Export leads</h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-5032">
              Export enriched leads with employee count, hiring signals, and
              more
            </p>
            <div data-id="element-5033">
              <div className="flex items-baseline gap-2" data-id="element-5034">
                <span className="text-4xl font-bold text-slate-900" data-id="element-5035">$0.15</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-5036">
                per 100 records exported
              </p>
            </div>
          </div>
        </div>

        {/* Trust Signals */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 mb-16" data-id="element-5037">
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-5038">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-5039" />
            <span data-id="element-5040">Pay only for results</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-5041">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-5042" />
            <span data-id="element-5043">Free credits to start</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-5044">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-5045" />
            <span data-id="element-5046">No credit card required</span>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-5047">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4" data-id="element-5048">
            <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-4 text-white font-bold bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors text-lg" data-id="element-5049">
              Try for free
            </a>
          </div>
          <p className="text-sm text-slate-500 font-medium" data-id="element-5050">
            No credit card required
          </p>
        </div>
      </div>
    </section>;
}